import React, {Component, useEffect, useImperativeHandle, useState} from 'react'
import {Modal, Form, Row, Col, Input, Collapse, Button, Steps, Popover, Select, InputNumber} from 'antd'
// import Editor from "../../../utils/brace";
import ApiManagementAPI from '../../../apis/apiManagementAPI'
import Editor from '../../../utils/brace'
import {withTranslation} from 'react-i18next'

const {Panel} = Collapse

const GroovyModal = (props) => {
  const {verVisible, handleCancel, id, ref, state, handleSetState, t} = props
  const [form] = Form.useForm()

  const formItemLayout = {
    labelCol: {span: 8},
    wrapperCol: {span: 16},
  }
  const formItemLayout2 = {
    labelCol: {span: 4},
    wrapperCol: {span: 20},
  }
  useEffect(() => {
    getGroovyDetail()
  }, [])
  const getGroovyDetail = () => {
    ApiManagementAPI.getGroovyDetailAction(id).then(res => {
      let resData = res.data.data
      form.setFieldsValue({
        client: resData.client,
        name: resData.name,
      })
      handleSetState('script', resData.script)
    })
  }
  return (
    <>
      <Modal
        title={t(`apiManagement.groovy`)}
        closable={false}
        visible={verVisible}
        maskClosable={false}
        destroyOnClose={true}
        width={1000}
        centered
        footer={[
          <Button key="Cancel" onClick={handleCancel}>{t(`general.cancel`)}</Button>
        ]}
      >

        <Form form={form} name="basic" autoComplete="off"
        >
          <Row wrap={true} gutter={[10, 20]}>
            <Col span={12}>
              <Form.Item label={t(`apiManagement.name`)} name="name" {...formItemLayout}>
                <Input disabled/>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item style={{margin: 0,}} name="client" label={t(`apiManagement.module`)} {...formItemLayout}>
                <Select
                  placeholder={t(`apiManagement.SelectModule`)}
                  disabled
                >
                  <Select.Option key="DataSource" value="DATASOURCE">DataSource</Select.Option>
                  <Select.Option key="DataTarget" value="DATATARGET">DataTarget</Select.Option>
                  <Select.Option key="InBoundAPI" value="INBOUNDAPI">InBound API</Select.Option>
                  <Select.Option key="OutBoundAPI" value="OUTBOUNDAPI">OutBound API</Select.Option>
                  <Select.Option key="Mapping" value="MAPPING">Mapping</Select.Option>
                  <Select.Option key="Mappingpre" value="MAPPINGPRE">Mapping pre</Select.Option>
                  <Select.Option key="Mappingpost" value="MAPPINGPOST">Mapping post</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={24}>
              <Collapse defaultActiveKey={['1', '2', '3']}>
                <Panel header={t(`apiManagement.script`)} key="1">
                  {
                    <Editor
                      ref={ref}
                      mode="json"
                      width="100%"
                      height="300px"
                      theme="chrome"
                      enableBasicAutocompletion={false}
                      enableLiveAutocompletion={false}
                      enableSnippets={false}
                      enableEmmet={false}
                      useElasticTabstops={false}
                      setOptions={{useWorker: false}}
                      fontSize="16px"
                      value={state.script ? state.script : null}
                      readonly={false}
                    ></Editor>
                  }
                </Panel>
              </Collapse>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  )
}

export default withTranslation()(GroovyModal)
